import Router from 'next/router';

import { type Board } from '@air/api/types';

import { createBoardRoute } from '~/constants/routes';

export const defaultBoard: Board = {
  id: '',
  creatorId: '',
  parentId: '',
  workspaceId: '',
  title: '',
  description: '',
  createdAt: '',
  updatedAt: '',
  permissions: {
    canEdit: true,
    canDelete: true,
    canView: true,
    canCreate: true,
    canManageMembers: true,
  },
  // @ts-expect-error - https://github.com/AirLabsTeam/next/pull/244#discussion_r502839412
  hasCurrentUser: null,
};

// TODO: request returns incorrect value of hasCurrentUser - it's always true
// Adding ignoreHasCurrentUser will prevent using this board's value for hasCurrentUser
// https://air-labs-team.slack.com/archives/CCS4C8ALT/p1612476953164300
export const getUpdatedBoard = ({
  newBoard,
  oldBoard,
  ignoreHasCurrentUser,
}: {
  newBoard: Partial<Board>;
  oldBoard?: Board;
  ignoreHasCurrentUser?: boolean;
}): Board => {
  let hasCurrentUser = !!newBoard.hasCurrentUser;

  if (ignoreHasCurrentUser) {
    hasCurrentUser = !!oldBoard?.hasCurrentUser;
  }

  const thumbnails = newBoard.thumbnails !== undefined ? newBoard.thumbnails : oldBoard?.thumbnails;

  let ancestors: Board['ancestors'];

  if (newBoard.ancestors) {
    ancestors = newBoard.ancestors;
  } else if (oldBoard?.ancestors) {
    ancestors = oldBoard.ancestors;
  }

  return {
    ...(oldBoard || defaultBoard),
    ...newBoard,
    ancestors,
    thumbnails,
    hasCurrentUser,
  };
};

export const addBoardTitleToURL = (board: { id: string; title: string }) => {
  const pathname = Router.asPath;
  const trailingPart = pathname.split(board.id)[1] || '';
  const boardUrlBase = createBoardRoute(board.id, board.title);
  const constructedPath = `${boardUrlBase}${trailingPart}`;

  if (constructedPath !== pathname) {
    Router.replace(constructedPath);
  }
};
